
import React,{useState,useEffect} from 'react'
import Dashboard from '../../components/dashboard/Dashboard'
import TaxComparison from '../../components/dashboard/TaxComparison'
import ReturnStatus from '../../components/dashboard/ReturnStatus'
import TaxableStatus from '../../components/dashboard/TaxableStatus'
import { motion } from 'framer-motion'
import UnderConstruction from '../../components/UnderConstruction'
import ExemptIncomePage from './ExemptIncomePage'
const ExemptIncome = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  
    useEffect(()=>{
      const isSidebarOpen = localStorage.getItem('isSidebarOpen') === 'true'
      setIsSidebarOpen(isSidebarOpen)
    },[])
  return (
    <Dashboard>
    <ExemptIncomePage/>
      {/* <UnderConstruction/> */}
    </Dashboard>
  )
}

export default ExemptIncome